// extracted by mini-css-extract-plugin
export var heading = "Shortcuts-module--heading--hZU60";
export var item = "Shortcuts-module--item--JW2RS";
export var itemLink = "Shortcuts-module--itemLink--soWpV";
export var line = "Shortcuts-module--line--N9fH5";
export var list = "Shortcuts-module--list--Q0k1U";
export var root = "Shortcuts-module--root--JdPkF";